export default "__VITE_ASSET__a3TGOHMQ__"